<template>
        <div class="card-body" v-loading="$parentInfo.studentWallet.dialog_WallAddCash.loading">
            <el-form :label-position="$parentInfo.studentWallet.dialog_WallAddCash.labelPosition">
                <el-row :gutter="15">
                    <el-col :span="6">
                        <el-form-item label="余额">
                            <el-input v-model="$store.state.modal.data.hasMoney" size="small" :disabled=true></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="纠纷余额">
                            <el-input v-model="$store.state.modal.data.disputeMoney" size="small"
                                      :disabled=true></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form v-if="$parentInfo.studentWallet.dialog_WallAddCash.paymentTypeJudge=true">
                <el-row :gutter="20">
                    <el-col :span="6" v-for="formItem in $parentInfo.studentWallet.dialog_WallAddCash.settleForm"
                            :key="formItem.id">
                        <el-form-item :label="formItem.name">
                            <el-input-number :min="0" v-model="formItem.balance" size="small"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form>
                <el-row :gutter="20">
                    <el-form-item label="原因">
                        <el-input v-model="$parentInfo.studentWallet.dialog_WallAddCash.remark" size="small"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>

            <div>总额：{{sumPay}}</div>

            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="primary" size="small" @click="handleAddStudentBalance()"
                           :loading="$parentInfo.studentWallet.dialog_WallAddCash.button_loading">充 值
                </el-button>
                <el-button type="primary" size="small" @click="handleDelStudentBalance()"
                           :loading="$parentInfo.studentWallet.dialog_WallAddCash.button_loading">提 现
                </el-button>
            </div>
        </div>
</template>

<script>
    export default {
        name: 'Dialog_WalletAddCash',
        data() {
            return {
            };
        },
        computed: {
            sumPay: function () {
                let sum = 0;
                for (let i = 0; i < this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm.length; i++) {
                    sum += Number(this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm[i].balance);
                }
                return sum;
            }
        },
        mounted() {
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentWallet.dialog_WallAddCash.loading = true;
            this.$parentInfo.studentWallet.dialog_WallAddCash.remark='';
            this.handleSettleCourses();
        },
        methods: {
            //支付方式
            handleSettleCourses() {
                this.$wApi.send(this.$parentInfo.path, 'settleCourses');
            },
            //充值
            handleAddStudentBalance() {
                this.$parentInfo.studentWallet.dialog_WallAddCash.button_loading = true;
                this.$parentInfo.studentWallet.dialog_WallAddCash.remark = '充值：' + this.$parentInfo.studentWallet.dialog_WallAddCash.remark;
                this.handleStoreStudentBalance(this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm);
            },
            //提现
            handleDelStudentBalance() {
                this.$parentInfo.studentWallet.dialog_WallAddCash.button_loading = true;
                for (let i = 0; i < this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm.length; i++) {
                    if (this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm[i].balance > 0) {
                        this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm[i].balance = 0 - Number(this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm[i].balance);
                    }
                }
                if (this.$store.state.modal.data.hasMoney + this.sumPay < 0) {
                    this.$message.error('提取金额不能大于余额');
                    this.$parentInfo.studentWallet.dialog_WallAddCash.button_loading = false;
                } else {
                    this.$parentInfo.studentWallet.dialog_WallAddCash.remark = '提现：' + this.$parentInfo.studentWallet.dialog_WallAddCash.remark;
                    this.handleStoreStudentBalance(this.$parentInfo.studentWallet.dialog_WallAddCash.settleForm);
                }
            },
            //提现充值操作
            handleStoreStudentBalance(balanceDetails) {
                this.$wApi.send(this.$parentInfo.path, 'storeStudentBalance', {
                    'student_id': this.$parentInfo.student_id,
                    'balanceDetails': balanceDetails,
                    'remark': this.$parentInfo.studentWallet.dialog_WallAddCash.remark,
                });
            },
        }
    };
</script>

<style scoped>

</style>
